export default {
  form: {
    country: {
      label: 'Land',
      placeholder: 'Land auswählen',
    },
  },
};
